import { useState } from 'react'
import PasswordInput from '../components/PasswordInput'
import BackButton from '../components/BackButton'

const initialForm = {
  email: '',
  password: '',
  fullName: '',
  age: '',
  weightKg: '',
  heightCm: '',
  level: 'principiante',
  daysPerWeek: 4,
  goal: '',
}

function Signup({ onFinish, saving, error, onBackToLogin }) {
  const [step, setStep] = useState(0)
  const [form, setForm] = useState(initialForm)
  const [localError, setLocalError] = useState('')

  function updateField(key, value) {
    setForm((old) => ({ ...old, [key]: value }))
  }

  function nextStep() {
    setLocalError('')

    if (step === 0) {
      if (!form.email.trim()) {
        setLocalError('Escribe tu email para continuar.')
        return
      }
      if (form.password.length < 6) {
        setLocalError('La contraseña debe tener al menos 6 caracteres.')
        return
      }
      if (!form.fullName.trim()) {
        setLocalError('Escribe tu nombre para continuar.')
        return
      }
    }

    if (step === 1) {
      const age = Number(form.age)
      const weight = Number(form.weightKg)
      const height = Number(form.heightCm)
      if (!age || !weight || !height) {
        setLocalError('Completa edad, peso y altura con numeros.')
        return
      }
    }

    if (step < 2) {
      setStep((old) => old + 1)
    }
  }

  function prevStep() {
    setLocalError('')
    setStep((old) => old - 1)
  }

  function handleFinish() {
    setLocalError('')

    if (!form.goal.trim()) {
      setLocalError('Describe tu objetivo principal.')
      return
    }

    onFinish(form)
  }

  return (
    <main className="screen onboarding-screen">
      <section className="onboarding-card">
        {step === 0 && <BackButton onClick={onBackToLogin} />}

        <p className="eyebrow">Programa de Calistenia Militar</p>
        <h1>Crea tu cuenta</h1>
        <p className="subtitle">Responde estos pasos y te muestro tu entrenamiento del dia.</p>

        <div className="step-indicator">
          <span className={step >= 0 ? 'active' : ''}>1</span>
          <span className={step >= 1 ? 'active' : ''}>2</span>
          <span className={step >= 2 ? 'active' : ''}>3</span>
        </div>

        {step === 0 && (
          <div className="question-block">
            <label>
              Email
              <input
                type="email"
                value={form.email}
                onChange={(event) => updateField('email', event.target.value)}
                placeholder="tu@email.com"
                autoFocus
              />
            </label>
            <label>
              Contraseña
              <PasswordInput
                value={form.password}
                onChange={(event) => updateField('password', event.target.value)}
                placeholder="Minimo 6 caracteres"
              />
            </label>
            <label>
              Nombre completo
              <input
                value={form.fullName}
                onChange={(event) => updateField('fullName', event.target.value)}
                placeholder="Ej: Carlos Ramirez"
              />
            </label>
          </div>
        )}

        {step === 1 && (
          <div className="question-block">
            <label>
              Edad
              <input
                type="number"
                inputMode="numeric"
                value={form.age}
                onChange={(event) => updateField('age', event.target.value)}
              />
            </label>
            <label>
              Peso (kg)
              <input
                type="number"
                inputMode="numeric"
                value={form.weightKg}
                onChange={(event) => updateField('weightKg', event.target.value)}
              />
            </label>
            <label>
              Altura (cm)
              <input
                type="number"
                inputMode="numeric"
                value={form.heightCm}
                onChange={(event) => updateField('heightCm', event.target.value)}
              />
            </label>
          </div>
        )}

        {step === 2 && (
          <div className="question-block">
            <label>
              Nivel
              <select value={form.level} onChange={(event) => updateField('level', event.target.value)}>
                <option value="principiante">Principiante</option>
                <option value="intermedio">Intermedio</option>
                <option value="avanzado">Avanzado</option>
              </select>
            </label>

            <label>
              Dias por semana
              <select
                value={form.daysPerWeek}
                onChange={(event) => updateField('daysPerWeek', Number(event.target.value))}
              >
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
              </select>
            </label>

            <label>
              Objetivo
              <textarea value={form.goal} onChange={(event) => updateField('goal', event.target.value)} />
            </label>
          </div>
        )}

        {(localError || error) && <p className="error-text">{localError || error}</p>}

        <div className="actions">
          {step > 0 && (
            <button type="button" className="secondary" onClick={prevStep}>
              Atras
            </button>
          )}

          {step < 2 ? (
            <button type="button" className="primary" onClick={nextStep}>
              Siguiente
            </button>
          ) : (
            <button type="button" className="primary" onClick={handleFinish} disabled={saving}>
              {saving ? 'Creando...' : 'Crear cuenta'}
            </button>
          )}
        </div>
      </section>
    </main>
  )
}

export default Signup
